module.exports = __webpack_public_path__ + "static/media/background.11f67032.png";